import {
  FormFieldWidget,
  isValidatorSuccess,
  ModelFieldType,
  SPI,
  ValidatorInfo,
  ValidatorStatus,
  ViewType,
  Widget,
  CallChaining
} from '@kunlun/dependencies';
import { OioMessage } from '@kunlun/vue-ui-antd';
import { cloneDeep } from 'lodash-es';
import ProductProperty from './ProductProperty.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.String,
    widget: 'ProductProperty',
    multi: false
  })
)
export class FormStringProductPropertyFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(ProductProperty);
    return this;
  }

  @Widget.Reactive()
  private formRef: any = null;

  @Widget.Reactive()
  private data: any = {};

  @Widget.Reactive()
  private customData: any = {};

  @Widget.Reactive()
  private cateAttrs: any = [];

  private submitData: any = {};

  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  protected mountedProcess(): void {
    // this._watchAttrs(this.formData);
  }

  private resetForm() {
    this.data = {};
    this.customData = {};
    this.cateAttrs = [];
    this.submitData = {};
  }

  // 切换类目时重新渲染
  @Widget.Watch('formData.categoryAttrs', { deep: true })
  private watchAttrs() {
    this._watchAttrs(this.formData);
  }

  private _watchAttrs(val: any) {
    this.resetForm();
    if (val?.categoryAttrs && val?.attributeOther) {
      const attributeOther: {
        [cateGroup: string]: {
          name: string;
          type: string;
          values: string[];
        }[];
      } = JSON.parse(val.attributeOther);

      this.cateAttrs = cloneDeep(val.categoryAttrs);
      this.cateAttrs.forEach((i) => {
        let target;
        let groupName;
        Object.entries(attributeOther).find(([gName, group]) =>
          group.find((obj) => {
            if (obj.name === i.name) {
              target = obj;
              groupName = gName;
              return true;
            }
            return false;
          })
        );
        if (target) {
          i.options = target.values.map((a) => ({ label: a, value: a }));
        }
        i.groupName = groupName;
        i.isSelect = (i.customerOption ?? 0) === 0;
      });

      if (!val.attributeCommit) {
        // 创建时
        Object.entries(attributeOther).forEach(([groupName, group]) => {
          group.forEach((item) => {
            if (!this.data[groupName]) {
              this.data[groupName] = {};
            }

            this.data[groupName][item.name] = [];
            this.customData[item.name] = '';
            this.submitData[item.name] = {
              values: '',
              customValue: '',
              name: item.name,
              type: groupName
            };
          });
        });
      } else {
        // 编辑时
        const attributeCommit: {
          [groupName: string]: {
            values: string[];
            customValue: string;
            name: string;
            type: string;
          }[];
        } = JSON.parse(val.attributeCommit);
        Object.entries(attributeOther).forEach(([groupName, group]) => {
          group.forEach((item) => {
            const attributeObj = attributeCommit[groupName]?.find((el) => el.name === item.name);

            if (!this.data[groupName]) {
              this.data[groupName] = {};
            }

            if (attributeObj) {
              this.data[groupName][item.name] =
                attributeObj.values && typeof attributeObj.values === 'string'
                  ? (attributeObj.values as string).split(',')
                  : attributeObj.values;
              this.customData[item.name] = attributeObj.customValue;
              this.submitData[item.name] = {
                values: attributeObj.values,
                customValue: attributeObj.customValue,
                name: item.name,
                type: groupName
              };
            } else {
              this.data[groupName][item.name] = [];
              this.customData[item.name] = '';
              this.submitData[item.name] = {
                values: '',
                customValue: '',
                name: item.name,
                type: groupName
              };
            }
          });
        });
      }
    }
  }

  public async validator(): Promise<ValidatorInfo> {
    const res = await this.validatorSpecific(this.value);

    if (!isValidatorSuccess(res)) {
      return res;
    }
    // 自定义校验
    let flag = true;
    for (let i = 0; i < this.cateAttrs.length; i++) {
      const item = this.cateAttrs[i];
      const _value: string | string[] = this.data?.[item.groupName]?.[item.name] ?? [];
      const values: string[] = typeof _value === 'string' ? [_value] : _value;
      if (!item.groupName || (item.isRequired && values.length === 0 && !this.customData[item.name])) {
        flag = false;
      }
    }
    if (!flag) {
      OioMessage.error('请将商品属性填写完整!');
      return {
        message: '请将商品属性填写完整',
        status: ValidatorStatus.Error,
        path: ''
      };
    }

    const resObj: Record<string, any[]> = {};
    for (let i = 0; i < this.cateAttrs.length; i++) {
      const item = this.cateAttrs[i];
      if (!resObj[item.groupName]) {
        resObj[item.groupName] = [];
      }
      const _value: string | string[] = this.data?.[item.groupName]?.[item.name] ?? [];
      const values: string[] = typeof _value === 'string' ? [_value] : _value;

      const submitObj = this.submitData[item.name];
      const obj = {
        values,
        customValue: this.customData[item.name],
        name: item.name,
        type: item.groupName,
        customerOption: item.isSelect ? 0 : 1
      };
      resObj[item.groupName].push(obj);
    }
    this.formData.attributeCommit = JSON.stringify(resObj);

    return {
      message: '',
      status: ValidatorStatus.Success,
      path: ''
    };
  }
}
